import moment from 'moment'

export const transformClientsResponse = (response) => {
    const res = response.map((client) => {
        const {clientRequest, ...rest} = client
        return {
            ...clientRequest,
            ...rest,
        }
    })
    return res
}

export const formatDate = (date, format = 'DD-MM-YYYY') =>
    date && moment(date).format(format)

export const formatDateForServer = (date, format = 'YYYY-MM-DD') =>
    date && moment(date).format(format)

export const getPaginatedData = (data, page = 0, pageSize = 10) => {
    page = Number(page)
    pageSize = Number(pageSize)
    data = data.slice(page * pageSize, (page + 1) * pageSize)
    return data
}

export const getMonthsArray = (period) => {
    const {from, to} = period
    let startDate = moment(from)
    const endDate = moment(to)
    let months = []
    while (startDate <= endDate) {
        months.push(startDate.format('MMMM'))
        startDate = startDate.add(1, 'month')
    }
    return months
}

export const createChartDate = (months, count) =>
    months.map((month) => ({
        name: month,
        count: count,
    }))

export const constructUrl = (baseUrl, queryParams) => {
    const filteredParams = Object.entries(queryParams)
        .filter(([key, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')

    return filteredParams ? `${baseUrl}?${filteredParams}` : baseUrl
}
